import { t } from "@/i18n-js/instance";
import type { MarketingEmailTemplateContentType } from "@/react/types/MarketingEmailTemplates";
import { Button } from "@circle-react-uikit/Button";
import { Modal } from "@circle-react-uikit/ModalV2";
import { Icon } from "../../Icon";
import { useBroadcastData } from "../BroadcastDataContext";
import { TemplateCard } from "./TemplateCard";
import { TemplateGroup } from "./TemplateGroup";

const localeNamespace = "settings.emails.templates";

export function ListTemplates({
  onClose,
  onApply,
  onStartFromScratch,
}: {
  onClose: () => void;
  onApply: (
    templateId: number,
    contentType: MarketingEmailTemplateContentType,
  ) => void;
  onStartFromScratch: () => void;
}) {
  const { data } = useBroadcastData();
  const hasEmailContent = Boolean(data?.broadcast_content?.email_content);
  const hasFooter = !hasEmailContent;

  return (
    <>
      <div className="border-b-primary text-dark flex items-center justify-between border-b px-8 pb-5 pt-6">
        <Modal.Title size="sm">
          {t([localeNamespace, "template_library"])}
        </Modal.Title>
        <Modal.CloseButton onClick={onClose} />
      </div>
      <Modal.Body className="!px-0 pb-0 pt-6">
        <TemplateGroup>
          {({ templates }) =>
            templates.map(template => (
              <TemplateCard
                key={template.id}
                template={template}
                onApply={onApply}
              />
            ))
          }
        </TemplateGroup>
      </Modal.Body>
      {hasFooter && (
        <Modal.Footer className="flex justify-end pb-6 pt-4">
          <Button variant="secondary" large onClick={onStartFromScratch}>
            <div className="flex items-center gap-x-3">
              {t([localeNamespace, "or_start_from_scratch"])}
              <Icon type="16-arrow-right" size={16} />
            </div>
          </Button>
        </Modal.Footer>
      )}
    </>
  );
}
